import React from 'react';
import { Icon } from '@doxyme/ui';
export const CallSurveyCloseButton = ({ onClick }) => {
    return (<button className="call-quality-survey__close" onClick={() => onClick()}>
      <Icon className="call-quality-survey__icon" name='close' size='x-small'/>
    </button>);
};
